import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = [{
    title: 'Tomo 1 — Introducción a la Ganadería y Producción Animal'
  }, {
    title: 'Tomo 2 — Agricultura, Suelos, Fertilización y Riego'
  }, {
    title: 'Tomo 3 — Maquinaria Agrícola, Ganadería y Producción Sustentable'
  }, {
    title: 'Módulo 6 — Producción Bovina'
  }, {
    title: '12 Libros Complementarios completos'
  }, {
    title: 'Sección de Juegos Agropecuarios'
  }, {
    title: 'Bono Extra — Tomo 1'
  }, {
    title: 'Bono Extra — Tomo 2'
  }, {
    title: 'Bono Extra — Tomo 3'
  }, {
    title: 'Bono Extra — Tomo 4'
  }, {
    title: 'Garantía de 7 días sin preguntas'
  }, {
    title: 'Pago con tarjeta o Mercado Pago en pesos'
  }, {
    title: 'Acceso inmediato tras la compra'
  }, {
    title: 'Formato PDF listo para usar en el aula'
  }];
  return <section className="py-12 bg-[#f5f0e6] border-y border-[#e2e8f0]" data-id="element-148">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-149">
        <h3 className="text-2xl font-bold text-center mb-10 text-[#1a3622]" data-id="element-150">
          📦 TODO LO QUE INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-151">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-white transition-colors border border-transparent hover:border-[#e2e8f0]" data-id="element-152">
              <CheckCircle2 className="w-5 h-5 text-[#1a3622] shrink-0 mt-0.5" data-id="element-153" />
              <div data-id="element-154">
                <span className="text-[#4a3b32] font-bold text-[16px] block" data-id="element-155">
                  {item.title}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}